import {
  client,
  ProgramPatchPayload,
  ApplyEditsRequest,
  ApplyEditAddSchema,
} from "../../../lib/api";

// Mirror your exact object type shape here
export type VideoResultType = {
  type: "video_result";
  url: string;
  title: string;
  description: string;
  age?: string;
  pageAge?: string;
  video?: {
    duration?: string;
    views?: number;
    creator?: string;
    publisher?: string;
  };
  metaUrl?: {
    hostname?: string;
  };
  thumbnail?: {
    src?: string;
    original?: string;
  };
  embedUrl?: string;
};

export type VideoSelectionMap = {
  [exerciseIndex: number]: {
    videoData: VideoResultType;
    savedVideoId?: string; // Stored after creating the embedded resource
  };
};

export const submitProgramPatchPipeline = async ({
  payload,
  videoSelections,
}: {
  payload: ProgramPatchPayload;
  videoSelections: VideoSelectionMap;
}) => {
  const updatedSelections = { ...videoSelections };

  // 2. Map payload items using newly created database video IDs
  const programVideos: ApplyEditAddSchema[] = payload.addProposals.map(
    (exercise, index) => {
      const selection = updatedSelections[index];

      return {
        url: selection?.videoData.url || "",
        title: exercise.title,
        description: exercise.description,
        role: exercise.role ?? "exercise",
        sets: (exercise.dosage as any)?.sets ?? null,
        reps: (exercise.dosage as any)?.reps ?? null,
        restSeconds: (exercise.dosage as any)?.restSeconds ?? null,
        tempo: (exercise.dosage as any)?.tempo ?? null,
        notes: exercise.description || null,
      };
    },
  );

  // 3. Dispatch the parent program post body
  return client.programs.postProgramsApplyEdits({
    id: payload.id,
    requestBody: {
      add: programVideos,
      archive: payload.archive,
    } satisfies ApplyEditsRequest,
  });
};
